var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { useWebgateAuth } from "../../infrastructure/providers/useWebgateAuth";
// O webgate sinaliza `initialized` (evento INITIALIZED) ANTES de o token ser
// resolvido por getAccessToken(), então um usuário AUTENTICADO passa por uma
// janela transitória de `initialized && !accessToken`. Chamar login() nessa
// janela reinicia o fluxo de auth do portal e remonta o app, recriando a mesma
// janela → loop infinito (visível ao voltar pra uma rota protegida depois de ir
// pra home do portal). Esperamos o token chegar antes de decidir pelo login.
export var TOKEN_GRACE_MS = 7000;
var Loader = function (_a) {
    var label = _a.label;
    return (_jsxs("div", __assign({ className: "flex flex-col items-center justify-center h-[60vh] gap-4" }, { children: [_jsx("div", { className: "w-10 h-10 border-4 border-blue-600 border-t-transparent rounded-full animate-spin", role: "status", "aria-label": label }), _jsx("span", __assign({ className: "text-sm text-gray-500" }, { children: label }))] })));
};
export var ProtectedRoute = function (_a) {
    var children = _a.children;
    var _b = useWebgateAuth(), accessToken = _b.accessToken, initialized = _b.initialized, loadingProfile = _b.loadingProfile, citizenId = _b.citizenId, login = _b.login;
    var loginTriggered = useRef(false);
    useEffect(function () {
        if (!initialized || accessToken)
            return;
        // Token ainda pode chegar (init em andamento p/ usuário autenticado). Só
        // redireciona pro login se continuar sem token após a tolerância, e uma vez.
        var timer = setTimeout(function () {
            if (!loginTriggered.current) {
                loginTriggered.current = true;
                login();
            }
        }, TOKEN_GRACE_MS);
        return function () { return clearTimeout(timer); };
    }, [initialized, accessToken, login]);
    if (!initialized)
        return _jsx(Loader, { label: "Conectando ao Gov.br..." });
    if (!accessToken)
        return _jsx(Loader, { label: "Redirecionando para o login..." });
    if (loadingProfile || !citizenId)
        return _jsx(Loader, { label: "Carregando perfil do cidad\u00E3o..." });
    return _jsx(_Fragment, { children: children });
};
